import React from "react";
import Header from "../Components/Header/Header";
import Nav from "../Components/Nav/Nav";
import About from "../Components/About/About";
import Experience from "../Components/Experience/Experience";
import Projects from "../Components/Projects/Projects";
import Contact from "../Components/Contact/Contact";
import Footer from "../Components/Footer/Footer";

const Info = () => {
  return (
    <>
      <Header />
      <Nav />
      <About />
      <Experience />
      <Projects />
      <Contact />
      <Footer />
    </>
  );
};

export default Info;
